var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4904,
    cy: 11.5338,
    r: 11.5338,
    fill: "#F93939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26087 0.461353C4.46278 1.85765 0.956543 6.2864 0.956543 11.5338C0.956543 16.7813 4.46278 21.21 9.26087 22.6063V0.461353Z",
    fill: "#249F58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39261 14.2097C10.9942 14.2097 12.2925 12.8877 12.2925 11.257C12.2925 9.6263 10.9942 8.30435 9.39261 8.30435C7.79102 8.30435 6.49268 9.6263 6.49268 11.257C6.49268 12.8877 7.79102 14.2097 9.39261 14.2097Z",
    fill: "#FFDA2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.326 12.2412V9.28855H7.45947V12.2412C7.45947 12.7845 8.32462 13.2254 9.39276 13.2254C10.4609 13.2254 11.326 12.7845 11.326 12.2412Z",
    fill: "#F93939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42627 10.2728H10.3603V12.242H8.42627V10.2728Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42627 10.2728H9.3933V11.2574H8.42627V10.2728ZM9.3933 11.2574H10.3603V12.242H9.3933V11.2574Z",
    fill: "#1A47B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.9c66b8c126cb7f790e1943a10ae5b63b.svg";
export { ForwardRef as ReactComponent };